import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/Rform/:campaign/:fiche',
    name: 'SeismicForm',
    component: () => import(/* webpackChunkName: "core" */ '../views/RForm.vue')
  },
  {
    path: '/Dform/:campaign/:fiche',
    name: 'DeresmaForm',
    component: () => import(/* webpackChunkName: "core" */ '../views/DForm.vue')
  },
  {
    path: '/DGform/:campaign/:fiche',
    name: 'DeresmaGaineForm',
    component: () => import(/* webpackChunkName: "core" */ '../views/DGForm.vue')
  },
  {
    path: '/teams',
    name: 'Teams',
    component: () => import(/* webpackChunckName: "core" */ '../views/Teams.vue')
  },
  {
    path: '/print-campaign/:campaign',
    name: 'Print',
    component: () => import(/* webpackChunckName: "core" */ '../views/PrintableForm.vue')
  },
  {
    path: '/import-campaign',
    name: 'Import',
    component: () => import(/* webpackChunckName: "desktop" */ '../views/CampaignImport.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
